export default "__VITE_ASSET__154a3cc4__"